export const handleScrollDown = () => {
  window.scrollTo({
    top: window.innerHeight,
    behavior: "smooth",
  });
};
export const handleScrollUp = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};
